<template>
    <div class="sidebar-container">
      <div class="collapse-button">
        <zm-button type="icon" icon="zm-icon-forward" v-if="isCollapse" @click="isCollapse = !isCollapse"></zm-button>
        <zm-button type="icon" icon="zm-icon-backward" v-if="!isCollapse" @click="isCollapse = !isCollapse"></zm-button>
      </div>
      <zm-menu
        :default-active="$route.path"
        class="zm-menu-vertical-demo"
        router
        :collapse="isCollapse">
          <zm-menu-item index="/csms/dashboard" v-permission="'menu-dashboard'">
            <i class="iconfont icon-dashboard" style="margin-left: -2px;"></i>
            <span slot="title">Dashboard</span>
          </zm-menu-item>
          <zm-menu-item index="/csms/application" v-permission="'menu-application'">
            <i class="iconfont icon-icon_application_outline"></i>
            <span slot="title">Application</span>
          </zm-menu-item>
          <zm-submenu index="/csms/secret" v-permission="'menu-secret'">
            <template slot="title">
              <i class="iconfont icon-secret" style="font-size: 20px; margin-left: -2px;"></i>
              <span slot="title">Secret</span>
            </template>
            <zm-menu-item index="/csms/secret">Secret</zm-menu-item>
            <zm-menu-item index="/csms/statistics" v-permission="'menu-secret/statistics'" v-if="!saferDisplay">Statistics</zm-menu-item>
          </zm-submenu>
          <zm-menu-item index="/csms/policy" v-permission="'menu-policy'">
            <i class="iconfont icon-miniconsfilecertificate"></i>
            <span slot="title">Policy</span>
          </zm-menu-item>
          <zm-menu-item index="/csms/instance" v-permission="'menu-instance'">
            <i class="iconfont icon-instance"></i>
            <span slot="title">Instance</span>
          </zm-menu-item>
          <zm-menu-item index="/csms/extend" v-permission="'menu-extend'">
            <i class="iconfont icon-certificate"></i>
            <span slot="title">Extend</span>
          </zm-menu-item>
      </zm-menu>
    </div>
</template>
<script>
// import { getMenuList } from '@/api/permission'
export default {
    name: 'sidebar',
    data () {
      return {
        // menuList: [],
        saferDisplay: localStorage.saferDisplay === 'true',
        permission: null,
        isCollapse: true
      }
    },
    created () {
      // get permission
      // getMenuList().then(response => {
      //   this.menuList = response.data
      // })
      // const permission = {
      //   frontPage: ['application', 'secret', 'dashboard'],
      //   resourcePermission: [
      //     {
      //       resources: ['appId1', 'appId2', 'appId3'],
      //       actions: {
      //           application: [
      //               'generateToken',
      //               'edit',
      //               'initCmk'
      //           ],
      //           secret: [
      //               'getValue'
      //           ],
      //           policy: [
      //               'createRole',
      //               'attach',
      //               'deleteRoleAndPath',
      //               'deleteRole'
      //           ],
      //           instance: [
      //               'retry'
      //           ],
      //           extend: [
      //               'delete'
      //           ]
      //       }
      //     }
      //   ]
      // }
      // this.permission = permission
      // localStorage.permission = JSON.stringify(permission)
    },
    methods: {
    }
}
</script>
<style>
@import '../../assets/icons/iconfont.css';
.sidebar-container {
    float: left;
    margin-right: -170px;
    /* border-right: 1px solid #d8dce5; */
    border-top: 1px solid #d8dce5;
    margin-top: 60px;
    height: calc(100vh - 117px);
}
.zm-menu-vertical-demo:not(.zm-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.zm-menu-vertical-demo {
  height: 100%;
}
.collapse-button {
  border-right: 1px solid #d8dce5;
  padding: 10px;
}
.zm-menu-item {
  height: 45px;
  line-height: 45px;
  font-size: 14px;
}
.iconfont {
  margin-right: 10px;
}
</style>
